<template>
    <div>
        <div class="wrapper-page">
            <div class="card">
                <div class="card-body">
                    <h3 class="text-center m-0">
                        <a class="logo logo-admin" href="javascript:void(0);">
                            <img alt="logo" height="30" src="/images/logo/foundri-logo.png"/>
                        </a>
                    </h3>
                    <div class="p-3">
                        <form @submit.prevent="submit" class="form-horizontal m-t-30">
                            <div class="form-group">
                                <label>Email</label>
                                <input :class="{ 'parsley-error' : form.errors.has('email') }"
                                       class="form-control"
                                       placeholder="Enter email"
                                       type="text"
                                       v-model="form.email">
                                <ul :class="{'filled' : form.errors.has('email')}"
                                    class="parsley-errors-list">
                                    <li class="parsley-required">
                                        {{ form.errors.get('email') }}
                                    </li>
                                </ul>
                            </div>
                            <div class="form-group">
                                <label>Password</label>
                                <input :class="{ 'parsley-error' : form.errors.has('password') }"
                                       class="form-control"
                                       placeholder="Enter new password"
                                       type="password"
                                       v-model="form.password">
                                <ul :class="{'filled' : form.errors.has('password')}"
                                    class="parsley-errors-list">
                                    <li class="parsley-required">
                                        {{ form.errors.get('password') }}
                                    </li>
                                </ul>
                            </div>
                            <div class="form-group">
                                <label>Confirm Password</label>
                                <input :class="{ 'parsley-error' : form.errors.has('password_confirmation') }"
                                       class="form-control"
                                       placeholder="Confirm new password"
                                       type="password"
                                       v-model="form.password_confirmation">
                                <ul :class="{'filled' : form.errors.has('password_confirmation')}"
                                    class="parsley-errors-list">
                                    <li class="parsley-required">
                                        {{ form.errors.get('password_confirmation') }}
                                    </li>
                                </ul>
                            </div>
                            <div class="form-group row mt-4">
                                <div class="col-12 text-center">
                                    <button :disabled="form.busy"
                                            class="btn btn-primary w-md waves-effect waves-light"
                                            type="submit">Reset Password
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Routes from "@/constants/routes";

    export default {
        data() {
            return {
                Routes,
                form: new Form({
                    token: null,
                    email: null,
                    password: null,
                    password_confirmation: null
                }, {
                    token: 'required',
                    email: 'required|email',
                    password: 'required|confirmed|min:6',
                    password_confirmation: 'required|min:6'
                })
            }
        },
        mounted() {
            this.form.token = this.$route.params.token;
            this.form.email = this.$route.query.email;
        },
        methods: {
            submit() {
                this.form.validate()
                    .then(() => {
                        App.post('/password/reset', this.form)
                            .then(() => {
                                window.location.href = '/';
                            });
                    });
            }
        }
    }
</script>

<style scoped>

</style>
